import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { ProductVariantWidgetComponent } from "../product-variant-widget/product-variant-widget.component";

@Component({
    selector: "app-formly-product-variant-widget",
    templateUrl: "./formly-product-variant-widget.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ProductVariantWidgetComponent,
    ]
})
export class FormlyProductVariantWidgetComponent extends FieldType {
    constructor(private cdRef: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        // this.getProductId();
        // this.formControl?.valueChanges.subscribe(x => {
        //   this.getProductId();
        // });
        console.log("MODEL", this.model);
    }
}